import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Controller, useForm } from 'react-hook-form';
import {
  Collapse,
  Card,
  Grid,
  TextField,
  MenuItem, Autocomplete,
} from '@mui/material';
import { useAppContext } from '../../../../../contexts/AppContext';
import { TableFilterButtons } from '../../../../common/TableFilterButtons';

export function GHETableFilter({ isOpenFilters, isLoadingList, empresas, categorias }) {
  const { setEmpresaIdSession } = useAppContext();

  const [searchParams, setSearchParams] = useSearchParams()

  const nome = searchParams.get('nome');
  const id_empresa = searchParams.get('id_empresa');
  const id_categoria = searchParams.get('id_categoria');

  const perPage = searchParams.get('perPage');

  const { handleSubmit, reset, control } = useForm();

  useEffect(() => {
    reset({
      nome: nome ?? '',
      cod_externo: searchParams.get('cod_externo') ?? '',
      id_empresa: id_empresa ?? '',
      id_categoria: id_categoria ?? '',
    });
  }, [id_empresa, nome, id_categoria, reset])

  function handleSubmitFilter(data) {
    for (const key in data) {
      // remove campos vazios
      if (data[key] === '') {
        delete data[key];
      }
    }

    const queryFilters = {
      ...data,
      page: '1',
      perPage: perPage ?? '10'
    }

    // fill url params with filters
    setSearchParams(queryFilters);

    if (data.id_empresa) {
      setEmpresaIdSession(data.id_empresa);
    }
  }

  return (
    <Grid item xs={12} component="form" onSubmit={handleSubmit(handleSubmitFilter)}>
      <Collapse in={isOpenFilters}>
        <Card variant="outlined" sx={{ padding: 2 }}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={4}>
              <Controller
                name="nome"
                control={control}
                defaultValue=""
                render={({ field }) => (
                  <TextField
                    label="Nome do Grupo"
                    fullWidth
                    size="small"
                    {...field}
                  />
                )}
              />
            </Grid>

            <Grid item xs={12} md={4}>
              <Controller
                name="cod_externo"
                control={control}
                defaultValue=""
                render={({ field }) => (
                  <TextField
                    label="Código Externo"
                    fullWidth
                    size="small"
                    {...field}
                  />
                )}
              />
            </Grid>

            <Grid item xs={12} md={4}>
              <Controller
                name="id_empresa"
                control={control}
                defaultValue=""
                render={({ field }) => (
                  <TextField
                    select
                    label="Empresa"
                    fullWidth
                    size="small"
                    {...field}
                  >
                    {empresas.length > 0 && empresas.map((option) => (
                      <MenuItem key={option.id} value={option.id}>
                        {option.nomeFantasia}
                      </MenuItem>
                    ))}
                  </TextField>
                )}
              />
            </Grid>

            <Grid item xs={12} md={4}>
              <Controller
                  name="id_categoria"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                      <Autocomplete
                          options={categorias}
                          getOptionLabel={(option) => option?.nome ?? ''}
                          isOptionEqualToValue={(option, value) =>
                              String(option.categorias_id?.[0]) === String(value?.categorias_id?.[0])
                          }
                          value={
                              categorias.find(
                                  (cat) =>
                                      String(cat.categorias_id?.[0]) === String(field.value)
                              ) ?? null
                          }
                          onChange={(_, newValue) => {
                            field.onChange(
                                newValue?.categorias_id?.[0]
                                    ? String(newValue.categorias_id[0])
                                    : ''
                            );
                          }}
                          size="small"
                          renderInput={(params) => (
                              <TextField
                                  {...params}
                                  label="Categoria"
                                  fullWidth
                                  size="small"
                              />
                          )}
                      />
                  )}
              />
            </Grid>

            <TableFilterButtons
              isLoading={isLoadingList}
              handleClearFilters={() => {
                setSearchParams((state) => {
                  state.delete('nome')
                  state.delete('cod_externo')
                  state.delete('id_categoria')
                  // state.delete('id_empresa') // dont delete id_empresa, because it saved in session
                  state.set('page', '1')

                  return state
                })

                reset({
                  nome: '',
                  cod_externo: '',
                  id_empresa: id_empresa ?? '',
                  id_categoria: ''
                });
              }}
            />
          </Grid>
        </Card>
      </Collapse>
    </Grid>
  );
}
